import React, { useState } from 'react';
import { patchPassword } from './Profile';

const OrgPasswordSection = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [reEnterPassword, setReEnterPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleApplyNewPassword = async () => {
    if (newPassword !== reEnterPassword) return alert("Passwords do not match.");

    try {
      await patchPassword({ oldPassword, newPassword, confirmPassword: reEnterPassword });
      alert('Password updated successfully.');
      setOldPassword('');
      setNewPassword('');
      setReEnterPassword('');
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="w-100 h-100 d-flex flex-column">

      <h5 className="text-center mb-4">Change Password</h5>

      <div className="mb-3">
        <label className="form-label">Old Password</label>
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">New Password</label>
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Re-enter New Password</label>
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          value={reEnterPassword}
          onChange={(e) => setReEnterPassword(e.target.value)}
        />
      </div>

      <div className="form-check mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          id="showPassword"
          checked={showPassword}
          onChange={() => setShowPassword(!showPassword)}
        />
        <label className="form-check-label" htmlFor="showPassword">
          Show Passwords
        </label>
      </div>

      {/* Button below fields */}
      <div className="d-grid mt-3">
        <button className="btn btn-primary" onClick={handleApplyNewPassword}>
          Apply New Password
        </button>
      </div>

    </div>
  );
};

export default OrgPasswordSection;
